import { isDevelopment } from 'src/common/utils/isDevelopment';
import { isSnapshot } from 'src/common/utils/isSnapshot';

/* TODO: use template strings after typescript is updated
  export type StardogFeatures = {
    [key in `is${Capitalize<keyof typeof featureSupportVersions>}Supported`]: boolean;
  };
 */
export type StardogFeatures = {
  isAtomicGraphQlSchemaUpdateSupported: boolean;
  isAvailableDatabaseOptionsMethodSupported: boolean;
  isBiServerSupported: boolean;
  isClientSideQueryIdSupported: boolean;
  isCurrentPasswordSupported: boolean;
  isDatabaseListInfoSupported: boolean;
  isDataSourcePartialUpdateSupported: boolean;
  isDataSourceShareSupported: boolean;
  isDataSourceTestSupported: boolean;
  isDataSourcesSupported: boolean;
  isDbCreateWithPropertiesFileSupported: boolean;
  isEditingDataSourcesWithVgsSupported: boolean;
  isEphemeralLoginSupported: boolean;
  isFrequencyPredicatesSupported: boolean;
  isGraphQLStoredQueriesSupported: boolean;
  isIcvConstraintsEnabled: boolean;
  isImportNamespacesOverHttpSupported: boolean;
  isJsonExplainPlanSupported: boolean;
  isModelingAndDbExportPermissionsSupported: boolean;
  isMultiSchemaSupported: boolean;
  isNamedGraphAliasesSupported: boolean;
  isOverrideGraphQlDefaultLimitSupported: boolean;
  isPreserveExactMappingsSupported: boolean;
  isQueryProfilerSupported: boolean;
  isRequestServerPropertiesSupported: boolean;
  isSensitivePropertiesSupported: boolean;
  isSms2Supported: boolean;
  isStarchartSupported: boolean;
  isStoredQueryMetadataEditingSupported: boolean;
  isStoredQueryPathSupported: boolean;
  isStoredQueryReasoningAndDescriptionSupported: boolean;
  isTriggerServiceSupported: boolean;
  isUpdatedGetAllSupported: boolean;
  isUserRoleListEndpointsSupported: boolean;
  isVgAssociateWithDbSupported: boolean;
  isVgDatabaseChangeSupported: boolean;
  isVirtualTransparencySupported: boolean;
};

const defaultStardogFeatures: StardogFeatures = {
  isAtomicGraphQlSchemaUpdateSupported: false,
  isAvailableDatabaseOptionsMethodSupported: false,
  isBiServerSupported: false,
  isClientSideQueryIdSupported: false,
  isCurrentPasswordSupported: false,
  isDatabaseListInfoSupported: false,
  isDataSourcePartialUpdateSupported: false,
  isDataSourceShareSupported: false,
  isDataSourceTestSupported: false,
  isDataSourcesSupported: false,
  isDbCreateWithPropertiesFileSupported: false,
  isEditingDataSourcesWithVgsSupported: false,
  isEphemeralLoginSupported: true,
  isFrequencyPredicatesSupported: false,
  isGraphQLStoredQueriesSupported: false,
  isIcvConstraintsEnabled: true,
  isImportNamespacesOverHttpSupported: false,
  isJsonExplainPlanSupported: false,
  isModelingAndDbExportPermissionsSupported: false,
  isMultiSchemaSupported: false,
  isNamedGraphAliasesSupported: false,
  isOverrideGraphQlDefaultLimitSupported: false,
  isPreserveExactMappingsSupported: false,
  isQueryProfilerSupported: false,
  isRequestServerPropertiesSupported: false,
  isSensitivePropertiesSupported: false,
  isSms2Supported: false,
  isStarchartSupported: false,
  isStoredQueryMetadataEditingSupported: false,
  isStoredQueryPathSupported: false,
  isStoredQueryReasoningAndDescriptionSupported: false,
  isTriggerServiceSupported: false,
  isUpdatedGetAllSupported: false,
  isUserRoleListEndpointsSupported: false,
  isVgAssociateWithDbSupported: false,
  isVgDatabaseChangeSupported: false,
  isVirtualTransparencySupported: false,
};

type StudioFeatures = {
  isRepositoriesEnabled: boolean;
};

export const isStudioFeatureEnabled = isDevelopment() || isSnapshot();

const defaultStudioFeatures: StudioFeatures = {
  isRepositoriesEnabled: isStudioFeatureEnabled,
};

export class FeaturesState {
  constructor(
    public stardog: StardogFeatures = defaultStardogFeatures,
    public studio: StudioFeatures = defaultStudioFeatures
  ) {}
}
